import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {AccountDetailsFormValues} from "../types";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";

export function AccountDetailsFormAccountNumberFormField({
  accountName,
  isVerifyingAccountNumber,
  resetMutation,
  isMutationIdle,
}: {
  accountName: string | undefined;
  isVerifyingAccountNumber: boolean;
  isMutationIdle: boolean;
  resetMutation: () => void;
}) {
  const {control, watch} = useFormContext<AccountDetailsFormValues>();

  return watch("bankCode") ? (
    <div>
      <Space direction="vertical" size={24} style={{display: "flex"}}>
        <FormField
          id="accountNumber"
          label="Account number"
          renderInput={(id) => (
            <Controller
              control={control}
              name="accountNumber"
              render={({field: {onChange, ref, onBlur, value}, fieldState: {error}}) => (
                <Space direction="vertical" size={16} style={{display: "flex"}}>
                  <Input
                    id={id}
                    status={error?.message ? "error" : ""}
                    onChange={(e) => {
                      if (!isMutationIdle) {
                        resetMutation();
                      }
                      onChange(e);
                    }}
                    onBlur={onBlur}
                    size="large"
                    value={value}
                    placeholder="Enter account number"
                    ref={ref}
                    disabled={
                      !watch("countryCode") ||
                      !watch("bankCode") ||
                      isVerifyingAccountNumber
                    }
                  />
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              )}
            />
          )}
        />
        {accountName && (
          <p style={{fontSize: "1.4rem", textTransform: "uppercase", color: "#52C41A"}}>
            {accountName}
          </p>
        )}
      </Space>
    </div>
  ) : null;
}
